import React, { useEffect, useState } from "react";
import DefaultRefundRulesModal from "./modals/DefaultRefundRulesModal";
import Axios from "axios";
import { useLocation } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";

const RefundRules = () => {
  const location = useLocation();
  const { eventid, eventname, is_sponsorship } = location.state || {};
  const eventId = eventid;
  const [showModal, setShowModal] = useState(false);
  const [applicableFeeOne, setApplicableFeeOne] = useState(0);
  const [applicableFeeTwo, setApplicableFeeTwo] = useState(0);
  const [applicableFeeThree, setApplicableFeeThree] = useState(0);
  const [applicableFee0, setApplicableFee0] = useState(0);
  const [feeType, setFeeType] = useState("Percent (%)");
  const [feeTypeTwo, setFeeTypeTwo] = useState("Percent (%)");
  const [feeTypeThree, setFeeTypeThree] = useState("Percent (%)");
  const [feeType0, setFeeType0] = useState("Percent (%)");

  const [cutOffDaysOne, setCutOffDaysOne] = useState(14);
  const [cutOffDaysTwo, setCutOffDaysTwo] = useState(7);
  const [cutOffDaysThree, setCutOffDaysThree] = useState(3);
  const [cutOffDays0, setCutOffDays0] = useState(0);
  const [autoRefund, setAutoRefund] = useState(false);

  const [maxAttempts, setMaxAttempts] = useState(0);
  const [refundPolicyLocked, setRefundPolicyLocked] = useState(0);
  const [refundPolicyLockedAt, setRefundPolicyLockedAt] = useState("");

  const [successError, setSuccessError] = useState();
  const [errorDisplay, setErrorDisplay] = useState();
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  const [saveBtn, setSaveBtn] = useState("save-btn");
  const [disabled, setDisabled] = useState(false);

  const baseURL = "https://karamale.com/apps/kscanner/webservices.php";

  useEffect(() => {
    Axios.get(`${baseURL}?query=GET_REFUND_RULES&event_id=${eventId}`, {
      withCredentials: true,
    }).then((response) => {
      const res = response;
      setApplicableFeeOne(res.data.feeAmountOne);
      setApplicableFeeTwo(res.data.feeAmountTwo);
      setApplicableFeeThree(res.data.feeAmountThree);
      setApplicableFee0(res.data.feeAmountZero);
      setCutOffDaysOne(res.data.cutOffDaysOne || 14);
      setCutOffDaysTwo(res.data.cutOffDaysTwo || 7);
      setCutOffDaysThree(res.data.cutOffDaysThree || 3);
      setCutOffDays0(res.data.cutoffDaysZero || 0);
      setAutoRefund(res.data.autoRefund);
      setMaxAttempts(res.data.maxAttempts);
      setFeeType(res.data.feeTypeOne || "Percent (%)");
      setFeeTypeTwo(res.data.feeTypeTwo || "Percent (%)");
      setFeeTypeThree(res.data.feeTypeThree || "Percent (%)");
      setFeeType0(res.data.feeTypeZero || "Percent (%)");
      setRefundPolicyLocked(res.data.refundPolicyLocked ?? 0);
      setRefundPolicyLockedAt(response.data.refundPolicyLockedAt);
    });
  }, []);

  const updateRules = async () => {
    setLoading(true);
    setSaveBtn("btn-disabled");
    setDisabled(true);
    const data = new FormData();
    data.append("event_id", eventId);
    data.append("cutOffDaysOne", cutOffDaysOne);
    data.append("applicableFeeOne", applicableFeeOne);
    data.append("feeTypeOne", feeType);
    data.append("cutOffDaysTwo", cutOffDaysTwo);
    data.append("applicableFeeTwo", applicableFeeTwo);
    data.append("feeTypeTwo", feeTypeTwo);
    data.append("cutOffDaysThree", cutOffDaysThree);
    data.append("applicableFeeThree", applicableFeeThree);
    data.append("feeTypeThree", feeTypeThree);
    data.append("cutOffDays0", cutOffDays0);
    data.append("applicableFee0", applicableFee0);
    data.append("feeType0", feeType0);
    data.append("autoRefund", autoRefund);
    data.append("maxAttempts", maxAttempts);
    data.append("query", "UPDATE_REFUND_RULES");

    Axios({
      url: `${baseURL}`,
      method: "POST",
      data: data,
      withCredentials: true,
    })
      .then((response) => {
        const res = response.data;

        if (res.status === "success") {
          setSuccessError("success-login");
          setErrorDisplay("block");
          setError(res.message);
        } else {
          setSuccessError("error-login");
          setErrorDisplay("block");
          setError(res.message);
        }
      })
      .catch((error) => {
        setSuccessError("error-login");
        setErrorDisplay("block");
        setError(error.response.data.message);
        console.log(error.response.data.message);
      });

    setLoading(false);
    setSaveBtn("save-btn");
    setDisabled(false);

    setTimeout(() => {
      setErrorDisplay("none");
    }, 5000);
  };

  const handleCutOffDaysOne = (e) => {
    const offDaysOne = e.target.value;
    setCutOffDaysOne(offDaysOne);
  };

  const handleTypeOne = (e) => {
    const type = e.target.value;
    if (type === "percent") {
      setFeeType("Percent (%)");

      if (applicableFeeOne > 100) {
        setApplicableFeeOne(100);
      }
    } else {
      setFeeType("Flat fee (R)");
    }
  };

  const handleCutOffDaysTwo = (e) => {
    const offDaysTwo = e.target.value;
    setCutOffDaysTwo(offDaysTwo);
  };

  const handleTypeTwo = (e) => {
    const type = e.target.value;
    if (type === "percent") {
      setFeeTypeTwo("Percent (%)");

      if (applicableFeeTwo > 100) {
        setApplicableFeeTwo(100);
      }
    } else {
      setFeeTypeTwo("Flat fee (R)");
    }
  };

  const handleCutOffDaysThree = (e) => {
    const offDaysThree = e.target.value;
    setCutOffDaysThree(offDaysThree);
  };

  const handleTypeThree = (e) => {
    const type = e.target.value;
    if (type === "percent") {
      setFeeTypeThree("Percent (%)");

      if (applicableFeeThree > 100) {
        setApplicableFeeThree(100);
      }
    } else {
      setFeeTypeThree("Flat fee (R)");
    }
  };

  const handleCutOffDays0 = (e) => {
    const offDays0 = e.target.value;
    setCutOffDays0(offDays0);
  };

  const handleType0 = (e) => {
    const type = e.target.value;
    if (type === "percent") {
      setFeeType0("Percent (%)");

      if (applicableFee0 > 100) {
        setApplicableFee0(100);
      }
    } else {
      setFeeType0("Flat fee (R)");
    }
  };

  const handleAutoRefund = (e) => {
    const isChecked = e.target.checked;
    setAutoRefund(isChecked);
  };

  return (
    <>
      <div
        className={
          refundPolicyLocked == 1 ? "alert alert-warning p-2" : "d-none"
        }
        role={refundPolicyLocked == 1 ? "alert" : ""}
      >
        <p>
          Refund settings are locked because ticket sales have begun. This
          policy cannot be changed, and refund requests will follow the rules
          you set before your first sale.
        </p>
        <p>
          <b>Locked on:</b> {refundPolicyLockedAt}
          <br />
          All refund requests will be processed according to this policy.
        </p>
        <p>
          <span>NB:</span> If no refund setting was configured before sales
          began, this event is treated as non-refundable.
        </p>
      </div>
      <div
        className={
          refundPolicyLocked == 1 ? "d-none" : "row justify-content-center mb-3"
        }
      >
        <div className="col-12 p-0">
          <h5>Refund Rules</h5>
        </div>
        <div className={"col-12 text-left p-0"}>
          <label>
            <input
              type="checkbox"
              checked={autoRefund ? true : false}
              // value={autoRefund}
              onChange={handleAutoRefund}
              className="w-auto h-none"
            />{" "}
            Enable Auto-approve refunds
          </label>
          <div className={!autoRefund ? "d-none" : "alert alert-warning p-2"}>
            {" "}
            When automatic refund approval is enabled, Karamale processes refund
            requests without organizer intervention. If you’ve configured custom
            refund rules for your event, those rules will be used exclusively to
            evaluate each request. If no rules are configured, Karamale’s
            default system rules will apply. This automation streamlines refund
            handling, but for high-value or sensitive events, manual review is
            recommended.
          </div>
        </div>
        <div className="col-12 alert alert-light p-0">
          If no rules are set Karamale's defaults will be used to evaluate
          refund requests.{" "}
          <label className="color-blue" onClick={() => setShowModal(true)}>
            See rules
          </label>
        </div>
        <div className="col-lg-4 col-12 pl-0 pr-1">
          <div className="row mb-3 bg-light-silver border-radius-10 p-3">
            <div className="col-lg-4 col-4 pl-0 pr-1">
              <label>
                <span>Tier 1</span>
              </label>
              <input
                type="number"
                min={0}
                value={cutOffDaysOne}
                onChange={handleCutOffDaysOne}
                className="bg-white border-silver"
              />
            </div>
            <div className="col-lg-4 col-4 pl-1 pr-1">
              <label>
                <span>Type</span>
              </label>
              <select className="form-control" onChange={handleTypeOne}>
                <option value="percent" selected={feeType === "Percent"}>
                  %
                </option>

                <option value="flat" selected={feeType === "Flat"}>
                  Rand
                </option>
              </select>
            </div>
            <div className="col-lg-4 col-4 pl-1 pr-0">
              <label>
                <span>{feeType}</span>
              </label>
              <input
                type="number"
                value={applicableFeeOne}
                max={feeType === "Percent (%)" ? 100 : ""}
                min={0}
                className="bg-white border-silver"
                onChange={(e) => setApplicableFeeOne(e.target.value)}
              />
            </div>
            <div className="col-12 p-0">
              <label className="w-100 text-grey p-1 mb-0">
                {cutOffDaysOne} days before the event
              </label>
            </div>
          </div>
          <div className="row mb-3 pl-0 bg-light-silver border-radius-10 p-3">
            <div className="col-lg-4 col-4 pl-0 pr-1">
              <label>
                <span>Tier 2</span>
              </label>
              <input
                type="number"
                min={0}
                value={cutOffDaysTwo}
                onChange={handleCutOffDaysTwo}
                className="bg-white border-silver"
              />
            </div>
            <div className="col-lg-4 col-4 pl-1 pr-1">
              <label>
                <span>Type</span>
              </label>
              <select className="form-control" onChange={handleTypeTwo}>
                <option value="percent" selected={feeTypeTwo === "Percent"}>
                  %
                </option>

                <option value="flat" selected={feeTypeTwo === "Flat"}>
                  Rand
                </option>
              </select>
            </div>
            <div className="col-lg-4 col-4 pl-1 pr-0">
              <label>
                <span>{feeTypeTwo}</span>
              </label>
              <input
                type="number"
                value={applicableFeeTwo}
                max={feeTypeTwo === "Percent (%)" ? 100 : ""}
                min={0}
                className="bg-white border-silver"
                onChange={(e) => setApplicableFeeTwo(e.target.value)}
              />
            </div>
            <div className="col-12 p-0">
              <label className="w-100 text-grey p-1 mb-0">
                {cutOffDaysTwo} days before the event
              </label>
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-12 mb-3 pl-0 pr-1">
          <div className="row mb-3 bg-light-silver border-radius-10 p-3">
            <div className="col-4 pl-0 pr-1">
              <label>
                <span>Tier 3</span>
              </label>
              <input
                type="number"
                min={0}
                value={cutOffDaysThree}
                onChange={handleCutOffDaysThree}
                className="bg-white border-silver"
              />
            </div>
            <div className="col-4 pl-1 pr-1">
              <label>
                <span>Type</span>
              </label>
              <select className="form-control" onChange={handleTypeThree}>
                <option value="percent" selected={feeTypeThree === "Percent"}>
                  %
                </option>

                <option value="flat" selected={feeTypeThree === "Flat"}>
                  Rand
                </option>
              </select>
            </div>
            <div className="col-4 pl-1 pr-0">
              <label>
                <span>{feeTypeThree}</span>
              </label>
              <input
                type="number"
                value={applicableFeeThree}
                max={feeTypeThree === "Percent (%)" ? 100 : ""}
                min={0}
                className="bg-white border-silver"
                onChange={(e) => setApplicableFeeThree(e.target.value)}
              />
            </div>
            <div className="col-12 p-0">
              <label className="w-100 text-grey p-1 mb-0">
                {cutOffDaysThree} days before the event
              </label>
            </div>
          </div>

          <div className="row mb-0 bg-light-silver border-radius-10 p-3">
            <div className="col-4 pl-0 pr-1">
              <label>
                <span>Tier 4</span>
              </label>
              <input
                type="number"
                min={0}
                value={cutOffDays0}
                onChange={handleCutOffDays0}
                className="border-silver"
                readOnly={true}
              />
            </div>
            <div className="col-4 pl-1 pr-1">
              <label>
                <span>Type</span>
              </label>
              <select className="form-control" onChange={handleType0}>
                <option value="percent" selected={feeType0 === "Percent"}>
                  %
                </option>

                <option value="flat" selected={feeType0 === "Flat"}>
                  Rand
                </option>
              </select>
            </div>
            <div className="col-4 pl-1 pr-0">
              <label>
                <span>{feeType0}</span>
              </label>
              <input
                type="number"
                value={applicableFee0}
                max={feeType0 === "Percent (%)" ? 100 : ""}
                min={0}
                className="bg-white border-silver"
                onChange={(e) => setApplicableFee0(e.target.value)}
              />
            </div>
            <div className="col-12 p-0">
              <label className="w-100 text-grey p-1 mb-0">
                {cutOffDays0} days before the event
              </label>
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-12 p-0">
          <label>
            <span>Maximum attempts</span>
          </label>
          <input
            type="number"
            value={maxAttempts}
            min={0}
            onChange={(e) => setMaxAttempts(e.target.value)}
            placeholder="Refund request limit per ticket"
            className="bg-white border-silver"
          />
        </div>
        <div className="col-12 text-left mt-3 p-0">
          <label className="w-100 alert alert-info p-2">
            Refund requests made on the day of the event are disabled by
            default. To enable same-day refunds, set a refund percentage or flat
            fee on Tier 4 (Choose Type), then set a value. If both values are
            set to 0, refunds will remain disabled for this tier.
          </label>
        </div>

        <div className="col-12 text-right mt-0 p-0">
          <button onClick={updateRules} className={saveBtn} disabled={disabled}>
            {!loading ? "Save Rules" : ""}
            {loading ? <ClipLoader size={25} color="grey" /> : ""}
          </button>
        </div>
      </div>
      <DefaultRefundRulesModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
      />
      <div
        className={successError}
        style={{ display: errorDisplay, textAlign: "center" }}
      >
        {error}
      </div>
    </>
  );
};

export default RefundRules;
